import { render } from "./Mech.vue?vue&type=template&id=e723a928&scoped=true"
import script from "./Mech.vue?vue&type=script&lang=js"
export * from "./Mech.vue?vue&type=script&lang=js"

import "./Mech.vue?vue&type=style&index=0&id=e723a928&scoped=true&lang=css"

import exportComponent from "D:\\Desktop\\dragoncrew\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e723a928"]])

export default __exports__